import type { FC, PropsWithChildren } from "react";
import type { DropzoneState } from "react-dropzone";

type Props = {
	dropzone: DropzoneState;
	dropzoneText?: string;
} & PropsWithChildren;

const DropZoneWrapper: FC<Readonly<Props>> = ({
	children,
	dropzone,
	dropzoneText = "Drop files here!",
}) => {
	const { getRootProps, getInputProps, isDragActive } = dropzone;

	return (
		<div
			data-zone-text={dropzoneText}
			{...getRootProps()}
			className={`file-dropzone${isDragActive ? " active" : ""}`}
		>
			<input {...getInputProps()} className="file-dropzone" />
			{children}
		</div>
	);
};

export default DropZoneWrapper;
